import { Space, Typography } from "@payping/web-components";
import { CheckCircleFilled, ClockCircleFilled, CloseCircleFilled } from "@payping/icons";
import { DashboardChecksTypeEnum } from "@payping/api";
import { useAppTranslation } from "@/utils/useAppTranslation";

export const StatusElement = ({ completed }: { completed?: DashboardChecksTypeEnum }) => {
  const { t } = useAppTranslation();

  const CompletedEl = (
    <Space className={"color--success"}>
      <CheckCircleFilled width={"1em"} />
      <Typography.Text variant={"body2"}>{t("completed")}</Typography.Text>
    </Space>
  );
  const NotCompletedEl = (
    <Space className={"color--danger"}>
      <CloseCircleFilled width={"1em"} />
      <Typography.Text variant={"body2"}>{t("notCompleted")}</Typography.Text>
    </Space>
  );
  const PendingEl = (
    <Space className={"color--warning"}>
      <ClockCircleFilled width={"1em"} />
      <Typography.Text variant={"body2"}>{t("awaitingConfirmation")}</Typography.Text>
    </Space>
  );

  switch (completed) {
    case DashboardChecksTypeEnum.NotFilled:
      return NotCompletedEl;
    case DashboardChecksTypeEnum.AdminPending:
      return PendingEl;
    case DashboardChecksTypeEnum.Confirmed:
      return CompletedEl;
    default:
      return null;
  }
};
